import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatButtonModule } from '@angular/material/button';
import { MatCardModule } from '@angular/material/card';
import { SharedApiv2Module } from '@netfoundry-ui/shared/apiv2';
import { MatDialogModule } from '@angular/material/dialog';
import { MatTooltipModule } from '@angular/material/tooltip';
import { FormsModule } from '@angular/forms';
import { UiPipesModule } from '@netfoundry-ui/ui/pipes';
import { UiMessageModule } from '@netfoundry-ui/ui/message';
import { AgentModalComponent } from './agent-modal.component';
import { UiSelectButtonModule } from '@netfoundry-ui/ui/select-button';
import { Agent } from '@netfoundry-ui/shared/model';
import { BaseChartDirective } from 'ng2-charts';
import { OpenZitiConsoleLibModule } from 'ziti-console-lib';

@NgModule({
    imports: [
        CommonModule,
        MatButtonModule,
        MatButtonModule,
        MatCardModule,
        MatCardModule,
        MatCardModule,
        SharedApiv2Module,
        MatDialogModule,
        MatTooltipModule,
        FormsModule,
        UiPipesModule,
        UiMessageModule,
        UiSelectButtonModule,
        BaseChartDirective,
        OpenZitiConsoleLibModule
    ],
    declarations: [AgentModalComponent],
    exports: [AgentModalComponent],
})
export class FeatureAgentModalModule {}
